import StepShare from './StepShare.component';

export default StepShare;
